// @ts-nocheck
import axios from 'axios';

import API_ENDPOINTS from '../../const/ApiEndPoints';
import useAuth from '../Auth/useAuth';
import { useCallback } from 'react';

export default function useWorkflow() {
  const { getAllRoles } = useAuth();
  const createWorkflow = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.CREATE_WORKFLOW}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const cloneWorkflow = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.CLONE_WORKFLOW}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const generateTextToWorkflow = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.LLM.GENERATE_TEXT_TO_WORKFLOW}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getWorkflowList = () => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.GET_WORKFLOW_LIST}`
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const compileWorkflow = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.COMPILE_FLOW}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const updateWorkflow = (body) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.UPDATE_FLOW}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const checkWorkflowStateDeletable = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.CHECK_WORKFLOW_STATE_DELETABLE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getSingleWorkflow = useCallback((body, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.GET_SINGLE_WORKFLOW}`,
        { params: body, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  const saveDraftWorkflow = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.DRAFT_WORKFLOW}`,
        body,
        {
          // @ts-ignore
          loader: false,
          suppressErrorToast: true,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getDraftWorkflow = (workflowId) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.DRAFT_WORKFLOW}`,
        {
          params: {
            id: workflowId,
          },
          // @ts-ignore
          loader: false,
          suppressErrorToast: true,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const deleteDraftWorkflow = (workflowId) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.DRAFT_WORKFLOW}`,
        {
          params: {
            id: workflowId,
          },
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateDraftWorkflow = (body) => {
    return axios
      .put(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.DRAFT_WORKFLOW}`,
        {
          ...body,
        },
        {
          // @ts-ignore
          loader: false,
          suppressErrorToast: true,
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const fetchAllStates = (workflow = 'Default') => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.GET_ALL_STATES}`,
        { params: { workflowType: workflow } }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };
  const getNextPossibleState = ({ entityId, entityType }, loader = true) => {
    return axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.NEXT_POSSIBLE_STATE}`,
      {
        params: { entityId, entityType },
        loader: loader,
      }
    );
  };

  const getPrecheckTransition = ({ entityId, entityType }, loader = true) => {
    return axios.get(
      `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.MI.PRECHECK_TRANSITION}`,
      {
        params: { entityId, entityType },
        loader: loader,
      }
    );
  };

  const deleteWorkflow = (params) => {
    return axios
      .delete(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.DELETE_WORKFLOW}`,
        { params }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const updateWorkflowState = (body) => {
    return axios
      .post(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.UPDATE_STATE}`,
        body
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  };

  const getWorkflowGroups = useCallback((params, loader = true) => {
    return axios
      .get(
        `${API_ENDPOINTS.MODULE_BASE_URL.AUTH}${API_ENDPOINTS.WF.GET_WORKFLOW_GROUPS}`,
        { params, loader: loader }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw err;
      });
  }, []);

  return {
    createWorkflow,
    getWorkflowList,
    compileWorkflow,
    updateWorkflow,
    getSingleWorkflow,
    saveDraftWorkflow,
    getDraftWorkflow,
    deleteDraftWorkflow,
    updateDraftWorkflow,
    getAllRoles,
    fetchAllStates,
    getNextPossibleState,
    getPrecheckTransition,
    cloneWorkflow,
    deleteWorkflow,
    checkWorkflowStateDeletable,
    updateWorkflowState,
    generateTextToWorkflow,
    getWorkflowGroups,
  };
}
